module.exports = core_Library;